module.exports = __webpack_public_path__ + "img/opened-black-eye.d2b453bd.svg";